export const API_URL = process.env.REACT_APP_API_URL;

export const routeColors = [
  '#2563eb',
  '#16a34a',
  '#ca8a04',
  '#7c3aed',
  '#0891b2',
  '#ea580c',
  '#0f766e',
  '#4338ca',
  '#65a30d',
  '#475569',
  '#9333ea',
  '#0ea5e9',
  '#a16207',
];

export function todayIso() {
  return new Date().toISOString().slice(0, 10);
}

export function formatTime(value) {
  if (!value) return '--:--';
  return new Date(value).toLocaleTimeString('es-PE', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function normalizeDriverSettings(drivers) {
  const result = {};
  drivers.forEach((driver) => {
    result[driver.user_id] = {
      selected: !!driver.is_route_enabled,
      user_id: driver.user_id,
      driver_id: driver.id,
      name: driver.name || `Driver ${driver.user_id}`,
      latitude: driver.latitude || '',
      longitude: driver.longitude || '',
      max_packages: driver.max_packages_default || 25,
      route_zone: driver.route_zone || '',
      route_zones: driver.route_zones || (driver.route_zone ? [driver.route_zone] : []),
      zone_assignments: driver.zone_assignments || [],
      preferred_districts: driver.preferred_districts || [],
      district_assignments: driver.district_assignments || [],
      route_start_latitude: driver.route_start_latitude || '',
      route_start_longitude: driver.route_start_longitude || '',
      final_latitude: driver.final_latitude || '',
      final_longitude: driver.final_longitude || '',
    };
  });
  return result;
}

export function selectedDriversPayload(driverSettings, maxPackagesDefault) {
  return Object.values(driverSettings)
    .filter((driver) => driver.selected)
    .map((driver) => ({
      selected: true,
      user_id: driver.user_id,
      max_packages: Number(driver.max_packages || maxPackagesDefault),
      route_zone: driver.route_zone || driver.route_zones?.[0] || null,
      route_zones: driver.route_zones || [],
      zone_assignments: driver.zone_assignments || [],
      preferred_districts: driver.preferred_districts || [],
      district_assignments: driver.district_assignments || [],
      latitude: driver.latitude || null,
      longitude: driver.longitude || null,
      route_start_latitude: driver.route_start_latitude || null,
      route_start_longitude: driver.route_start_longitude || null,
      final_latitude: driver.final_latitude || null,
      final_longitude: driver.final_longitude || null,
    }));
}

export function driverPreferencePatch(driver, maxPackagesDefault) {
  return {
    route_zone: driver.route_zone || driver.route_zones?.[0] || null,
    route_zones: driver.route_zones || [],
    preferred_districts: driver.preferred_districts || [],
    district_assignments: driver.district_assignments || [],
    max_packages_default: Number(driver.max_packages || maxPackagesDefault),
    latitude: driver.latitude || null,
    longitude: driver.longitude || null,
    route_start_latitude: driver.route_start_latitude || null,
    route_start_longitude: driver.route_start_longitude || null,
    final_latitude: driver.final_latitude || null,
    final_longitude: driver.final_longitude || null,
    is_route_enabled: driver.selected,
  };
}

export function getPlanMapPoints(plan, preview) {
  if (plan?.routes?.length) {
    const routePoints = plan.routes.flatMap((route, routeIndex) =>
      (route.stops || [])
        .filter((stop) => stop.delivery?.latitude && stop.delivery?.longitude)
        .map((stop) => ({
          stop_id: stop.id,
          id: stop.delivery_point_id,
          lat: Number(stop.delivery.latitude),
          lng: Number(stop.delivery.longitude),
          district: stop.delivery.district,
          recipient_name: stop.delivery.recipient_name,
          slot: stop.delivery.slot || 0,
          priority: stop.is_priority || stop.delivery.priority,
          route_id: route.id,
          route_index: routeIndex,
          driver_name: route.driver_name,
          sequence: stop.sequence,
          eta: stop.planned_arrival_time,
          warning: stop.warning,
          unassigned: false,
          color: routeColors[routeIndex % routeColors.length],
        }))
    );
    const unassignedPoints = (plan.unassigned || [])
      .filter((item) => item.delivery?.latitude && item.delivery?.longitude)
      .map((item) => ({
        id: item.delivery_point_id,
        lat: Number(item.delivery.latitude),
        lng: Number(item.delivery.longitude),
        district: item.delivery.district,
        recipient_name: item.delivery.recipient_name,
        slot: item.delivery.slot || 0,
        priority: item.delivery.priority,
        route_id: null,
        route_index: null,
        driver_name: null,
        sequence: null,
        eta: null,
        warning: null,
        unassigned: true,
        unassigned_reason: item.reason,
        color: '#64748b',
      }));
    return [...routePoints, ...unassignedPoints];
  }

  return (preview?.deliveries || [])
    .filter((delivery) => delivery.latitude && delivery.longitude)
    .map((delivery) => ({
      id: delivery.id,
      lat: Number(delivery.latitude),
      lng: Number(delivery.longitude),
      district: delivery.district,
      recipient_name: delivery.recipient_name,
      slot: delivery.slot || 0,
      priority: delivery.priority,
      route_id: null,
      route_index: null,
      driver_name: null,
      sequence: null,
      eta: null,
      warning: null,
      color: delivery.priority ? '#E6B43C' : '#64748b',
    }));
}
